module.exports = __webpack_public_path__ + "img/persevere.ff7fa9bf.png";